import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';

export const utagFavoritesWatchlistClicked = (
  interactionEvent,
  callRedirect,
) => {
  const {
    event,
    interaction,
    extra = {},
    changeNameInteraction = true,
    addEventType = false,
  } = interactionEvent;
  const interactionType = {
    eventType: event,
    interaction,
    changeNameInteraction,
    addEventType,
  };
  const userInteractionEvent = createUserInteraction(interactionType, extra);
  trackEvent(userInteractionEvent);

  if (callRedirect) callRedirect();
};
